import { cIModelApi } from './IModelApi';
import { cRealityDataApi } from "./RealityDataApi";
import { cProjectApi } from './ProjectApi';
import { User } from "./User";

export class cUserManager {
  private static _user: User;

  public static async initializeUser() {
    await cIModelApi.initIModelApi();
    await cRealityDataApi.initRealityDataApi();
    await cProjectApi.initProjectApi();
    await cRealityDataApi.fetchRealityData(this._user.organization);
  }

  public static async getIModelId() {
    const iModel = await cIModelApi.getCurrentIModel(this._user.organization);
    return iModel.get("imodelId");
  }

  public static async getITwinId() {
    const projects = await cProjectApi.getProjects(this._user.organization);
    for (const project of projects) {
      if (project.get("Organization") === this._user.organization) {
        return project.get("ProjectId"); 
      }
    }
    return;
  }

  public static getRealityModels() {
    return cRealityDataApi.getUserRealityData();
  }

  public static getRealityModelsMap() {
    return cRealityDataApi.getRealityModelsMap();
  }

  public static setProperty(value: User) {
    this._user = value;
  }
  public static getProperty(): User {
    return this._user;
  }
}
